import React, { useEffect, useState } from 'react';
import Layout from '../../../components/common/pageLayout';
import { toast } from 'react-toastify';
import CategoryList from '../../../components/MasterData/PlanType/list';
import constant from '../../../constant';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_document_type_visibility, v3_document_types, v3_plan_type_visibility, v3_plan_types } from '../../../actions/v3/masterData';
import { replacePageState } from '../../../utils';

const List = (props) => {
    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null);
    const [currentPage, setCurrentPage] = useState(page || 1);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        v3_plan_types(currentPage, limit).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.listPlanTypeMasterData.url, {
                    page: currentPage
                });
            } else {
                toast.error(res.error);
            }
        });
    }, [currentPage, limit]);

    const onChangeVisibility = (record) => {
        const newStatus = !record.IS_ACTIVE;

        v3_plan_type_visibility(record.ID, newStatus).then((res) => {
            if (res.status) {
                setData(prevState => ({
                    ...prevState,
                    planTypes: prevState.planTypes.map(item => {
                        if (item.ID === record.ID) {
                            return {
                                ...item,
                                IS_ACTIVE: newStatus
                            };
                        }
                        return item;
                    })
                }));

                toast.success(res.result.message);
            } else {
                toast.error("Failed to update plan type visibility");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("An error occurred while updating plan type visibility");
        });
    };

    return (
        <Layout title={'Plan Type'}>
            {data && (
                <CategoryList
                    onChangeVisibility={onChangeVisibility}
                    limit={limit}
                    data={data}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            )}
        </Layout>
    );
};

export default List;
